import React, { useEffect, useMemo, useState } from 'react';
import { createColumnHelper, useReactTable, getCoreRowModel } from '@tanstack/react-table';
import useNotificationStore from '../../store/notification-store';
import DataTable from '../../shared/components/table/DataTable';
import PageHeader from '../../shared/components/table/PageHeader';
import RowActions from '../../shared/components/table/RowActions';
import ResourceFormModal from '../../shared/components/modal/ResourceFormModal';
import { toast } from 'react-toastify';
import { trimData } from '../../shared/lib/formatters';

const columnHelper = createColumnHelper();

const notificationFields = [
  { name: 'text', label: 'Text', type: 'textarea', rows: 6 },
];

const NotificationPage = () => {
  const { notification, fetchNotification, updateNotification } = useNotificationStore();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const openEditRef = React.useRef(() => {});

  useEffect(() => {
    const load = async () => {
      setIsLoading(true);
      await fetchNotification();
      setIsLoading(false);
    };
    load();
  }, [fetchNotification]);

  const columns = useMemo(
    () => [
      columnHelper.accessor('text', {
        header: 'Text',
        cell: (info) => (info.getValue() ? info.getValue() : '-'),
      }),
      columnHelper.accessor('actions', {
        header: 'Actions',
        cell: ({ row }) => (
          <RowActions onEdit={() => openEditRef.current(row.original)} />
        ),
      }),
    ],
    []
  );

  const data = useMemo(() => [notification], [notification]);
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  openEditRef.current = () => setIsFormOpen(true);

  const handleSubmit = async (formData) => {
    try {
      await updateNotification(trimData(formData));
      toast.success('Notification updated successfully');
      setIsFormOpen(false);
    } catch (error) {
      console.error('Failed to update notification:', error);
      toast.error('Failed to update notification. Please try again.');
    }
  };

  const initialValues = useMemo(
    () => ({ text: notification?.text || '' }),
    [notification]
  );

  return (
    <div className="max-w-screen-3xl mx-auto mt-4">
      <PageHeader title="Notification" />
      <div className="mt-12">
        <DataTable
          table={table}
          columnsCount={columns.length}
          isLoading={isLoading}
          emptyMessage="No notification found"
          enableSortingIndicator={false}
        />
      </div>
      <ResourceFormModal
        isOpen={isFormOpen}
        onClose={() => setIsFormOpen(false)}
        mode="edit"
        title="Edit Notification"
        fields={notificationFields}
        initialValues={initialValues}
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default NotificationPage;
